import { render, staticRenderFns } from "./PlayGame.vue?vue&type=template&id=a728496a&scoped=true&"
import script from "./PlayGame.vue?vue&type=script&lang=js&"
export * from "./PlayGame.vue?vue&type=script&lang=js&"
import style0 from "./PlayGame.vue?vue&type=style&index=0&id=a728496a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a728496a",
  null
  
)

export default component.exports